function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m1.4 0c-.76514396 0-1.4.63485604-1.4 1.4v11.2h9.8 4.2v-8.4c0-.76514396-.6348559-1.4-1.4-1.4h-2.8v-1.4c0-.76514396-.6348559-1.4-1.4-1.4zm0 1.4h7v9.8h-7zm1.4 1.4v1.4h1.4v-1.4zm2.8 0v1.4h1.4v-1.4zm4.2 1.4h2.8v7h-2.8v-1.4h1.4v-1.4h-1.4v-1.4h1.4v-1.4h-1.4zm-7 1.4v1.4h1.4v-1.4zm2.8 0v1.4h1.4v-1.4zm-2.8 2.8v1.4h1.4v-1.4zm2.8 0v1.4h1.4v-1.4z"
});

var SvgBuildings = function SvgBuildings(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 15,
    viewBox: "0 0 14 13",
    width: 16,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBuildings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/buildings.b8134cc5.svg";
export { ForwardRef as ReactComponent };